export default {
  data() {},
  created() {},
  mounted() {},
  unmounted() {},
  methods: {
    getVehiclePriceHistoryDetails(priceHistoryObject, currentPrice, dateOnLot) {
      // Calculate original listing price by working backwards from current price
      let originalListingPrice = parseFloat(currentPrice.toString());

      if (priceHistoryObject && priceHistoryObject.length > 0) {
        // Subtract all price changes to get back to original listing price
        priceHistoryObject.forEach(entry => {
          const change =
            parseFloat(entry.new_price) - parseFloat(entry.old_price);
          originalListingPrice -= change;
        });
      }

      // Create the Listed row
      const listedRow = {
        id: null,
        time_created: dateOnLot,
        old_price: null,
        new_price: originalListingPrice
      };

      // Sort price history by time_created descending (most recent first)
      const sortedHistory =
        priceHistoryObject && priceHistoryObject.length > 0
          ? [...priceHistoryObject].sort(
              (a, b) => new Date(b.time_created) - new Date(a.time_created)
            )
          : [];

      // Full price history with most recent first and Listed row at the end
      const full = [...sortedHistory, listedRow];

      // Latest price change (most recent entry in sorted history)
      const latest =
        sortedHistory.length > 0
          ? {
              amount_change:
                parseFloat(sortedHistory[0].new_price) -
                parseFloat(sortedHistory[0].old_price),
              time_created: sortedHistory[0].time_created
            }
          : {
              amount_change: 0,
              time_created: null
            };

      // Total price change (difference between current price and original listing price)
      const totalChange = parseFloat(currentPrice) - originalListingPrice;
      const total = {
        amount_change: totalChange,
        time_created:
          sortedHistory.length > 0 ? sortedHistory[0].time_created : null
      };

      return { latest, total, full };
    },
    addToClickedVehicles(vehicle) {
      let { ...vehicleLocalStorageEntry } = vehicle;
      delete vehicleLocalStorageEntry.description;
      delete vehicleLocalStorageEntry.features_raw;
      delete vehicleLocalStorageEntry.dealer;
      delete vehicleLocalStorageEntry.product_performance_rollup;
      vehicleLocalStorageEntry.time_clicked = Date.now();

      let existingRecentlyClickedVehicles = window.localStorage.getItem(
        "jfpc-clicked-vehicles"
      )
        ? JSON.parse(window.localStorage.getItem("jfpc-clicked-vehicles"))
        : [];
      if (existingRecentlyClickedVehicles.length >= 100) {
        existingRecentlyClickedVehicles = existingRecentlyClickedVehicles.slice(
          0,
          99
        );
      }
      if (
        existingRecentlyClickedVehicles.filter(
          ercv => ercv.product_id == vehicle.product_id
        ).length > 0
      ) {
        existingRecentlyClickedVehicles = existingRecentlyClickedVehicles.filter(
          ercv => ercv.product_id != vehicle.product_id
        );
      }
      existingRecentlyClickedVehicles.unshift(vehicleLocalStorageEntry);
      window.localStorage.setItem(
        "jfpc-clicked-vehicles",
        JSON.stringify(existingRecentlyClickedVehicles)
      );
    },
    handleClickedVehicle(vehicle) {
      this.fireViewContentEvents(vehicle.bid_value, [vehicle.product_id])
        .then(() => {
          this.addToClickedVehicles(vehicle);

          window.sessionStorage.setItem(
            window.location.hostname + "-lastScrollPosition",
            window.scrollY
          );

          if (vehicle.conversion_goal_event_type_id == 3) {
            window.jfpe.track("ContentClick", {
              advertiser_account_id: vehicle.advertiser_account_id,
              inventory_source_id: vehicle.inventory_source_id,
              product_id: vehicle.product_id,
              event_value: vehicle.bid_value
            });

            sessionStorage.setItem(
              window.location.hostname + "-adClicked",
              vehicle.advertiser_account_id
            );

            let urlParams = new URLSearchParams(window.location.search);
            let destUrl =
              "https://www.carscience.com/out/" +
              vehicle.advertiser_account_id +
              "?d=" +
              encodeURIComponent(vehicle.destination_url) +
              "&dlrn=" +
              encodeURIComponent(vehicle.dealer.name);
            let clickId =
              vehicle.advertiser_account_id +
              "|" +
              vehicle.product_id +
              "|" +
              (urlParams.get("utm_campaign") ?? "0") +
              "|" +
              (urlParams.get("split") ?? "0") +
              "|" +
              window.localStorage.getItem("jfpc-visitor-id");
            destUrl += "&jfcid=" + encodeURIComponent(btoa(clickId));
            window.location.href = destUrl;
          } else if (
            ["4", "7"].includes(
              vehicle.conversion_goal_event_type_id.toString()
            )
          ) {
            if (typeof this.promptVehicleListingDialog === "function") {
              this.promptVehicleListingDialog(vehicle.product_id);
            } else {
              window.location.href = "https://www.carscience.com?pid=" + vehicle.product_id;
            }
          }
        });
    }
  }
};
